export const FETCH_GEO_LOCATION = 'FETCH_GEO_LOCATION';
export const FETCH_GEO_LOCATION_START = 'FETCH_GEO_LOCATION_START';
export const GEOLOCATION_SERVICES_PERMISSIONS_DENIED = 'GEOLOCATION_SERVICES_PERMISSIONS_DENIED';
// export const LOADING_GEOLOCATION = 'LOADING_GEOLOCATION';
